import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import { API_URL } from "../config/app";

const URL = API_URL;

export const containerService = {
  getAll,
  create,
  deleteContainer,
  getById,
  getResume,
  addDocument,
  getDocuments,
  update,
  downloadAll,
  initMassiveUpload,
  completeMassiveUpload,
  getUploadProcesses
}

function getResume(uuid) {
    const requestOptions = {
        method: 'GET',
        headers: {
            ...authHeader(),
            'Accept': 'text/csv'
        }
    };

    //delete requestOptions.headers['Content-Type'];

    console.log('getResume Request Options:', requestOptions);

    return fetch(`${URL}/containers/${uuid}/resume`, requestOptions)
        .then(response => {
            console.log('getResume Response:', {
                status: response.status,
                statusText: response.statusText,
                headers: [...response.headers.entries()]
            });
            
            if (!response.ok) {
                if (response.status === 401) {
                    userService.refreshToken();
                    return Promise.reject("Intentando recuperar la sesión");
                }
                if (response.status === 406) {
                    console.warn("getResume: 406 Not Acceptable - Likely missing signatures");
                    return Promise.reject("Faltan documentos por firmar");
                }
                return Promise.reject(response.statusText);
            }
            return response.blob();
        });
}

function downloadAll(uuid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${URL}/containers/${uuid}/download`, requestOptions)
        .then(response => {
            if (!response.ok) {
                if (response.status === 401) {
                    userService.refreshToken();
                    return Promise.reject("Intentando recuperar la sesión");
                }
                return Promise.reject(response.statusText);
            }
            return response.blob();
        });
}

function addDocument(uuid, file) {
    const formData = new FormData();
    formData.append('document', file);

    const requestOptions = {
        method: 'POST',
        headers: authHeader(), // Note: Content-Type multipart/form-data is usually set automatically by browser when body is FormData
        body: formData
    };
    // Remove Content-Type header to let browser set it with boundary
    delete requestOptions.headers['Content-Type'];

    return fetch(`${URL}/containers/${uuid}/documents`, requestOptions)
        .then(handleResponse);
}

function getDocuments(uuid, search, status) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (status) {
        if (Array.isArray(status)) {
            status.forEach(s => params.append('status', s));
        } else {
            params.append('status', status);
        }
    }

    return fetch(`${URL}/containers/${uuid}/documents?${params.toString()}`, requestOptions)
        .then(handleResponse);
}

function getById(uuid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${URL}/containers/${uuid}`, requestOptions).then(handleResponse);
}

function deleteContainer(uuid) {
  const requestOptions = {
      method: 'DELETE',
      headers: authHeader()
  };

  return fetch(`${URL}/containers/${uuid}`, requestOptions).then(handleResponse);
}

function getAll(page, sort, search, status, start_date, end_date) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };


  const params = new URLSearchParams();
  if (page !== undefined && page !== null) params.append('page', page);
  if (sort) {
    params.append('sort', sort);
  } else {
    params.append('sort', 'createdAt,DESC');
  }
  if (search) params.append('search', search);
  if (status) params.append('status', status);
  if (start_date) params.append('start_date', start_date);
  if (end_date) params.append('end_date', end_date);


  params.append('size', 10);
  params.append('_t', new Date().getTime()); // Prevent 304 Not Modified cache
  const requestUrl = `${URL}/containers?${params.toString()}`;

  return fetch(requestUrl, requestOptions)
    .then(handleResponse)
    .then(response => {
      let data = [];
      response.data.forEach(resp => {
        data.push({
          id: resp.id,
          uuid: resp.id,
          name: resp.attributes.name,
          status: resp.attributes.status,
          created_at: resp.attributes.created_at,
          updated_at: resp.attributes.updated_at,
          description: "",
          document_quantity: 0,
        })
      })
      return Promise.resolve({
        data,
        pagination: response.meta ? response.meta : null
      })
    })
}

function create(data) {
  
    const headers = authHeader();
    delete headers['Content-Type'];

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('status', 'ON_HOLD'); 
    if (data.description) formData.append('description', data.description);
    formData.append('tries', data.tries);
    formData.append('remember_every', data.remember_every);
    formData.append('remember_at', data.remember_at);
    formData.append('sign_mode', data.sign_mode);
    if (data.logo) formData.append('logo', data.logo);
    formData.append('sign_position', data.sign_position);
    formData.append('mode_logo', data.mode_logo);
    formData.append('sign_ordered', data.sign_ordered);
    formData.append('notification_mode', data.notification_mode);
    formData.append('webhook', '');
    
    if (data.signatures && Array.isArray(data.signatures)) {
      data.signatures.forEach((sig, index) => {
          formData.append(`signatures[${index}].name`, sig.name);
          formData.append(`signatures[${index}].email`, sig.email);
          if(sig.phone) formData.append(`signatures[${index}].phone`, sig.phone);
          if(sig.rfc) formData.append(`signatures[${index}].rfc`, sig.rfc);
          if(sig.curp) formData.append(`signatures[${index}].curp`, sig.curp);
      });
    }
    
    if (data.spectators && Array.isArray(data.spectators)) {
      data.spectators.forEach((spectator, index) => {
        formData.append(`spectators[${index}].name`, spectator.name);
        formData.append(`spectators[${index}].email`, spectator.email);
      });
    }
    
    //formData.append('logo', data.logo);

    return fetch(`${URL}/containers`, {
        method: 'POST',
        headers: headers,
        body: formData
    }).then(handleResponse);
}

function update(uuid, data) {
  const headers = authHeader();
  delete headers['Content-Type'];

  const formData = new FormData();
  if (data.name) formData.append('name', data.name);
  if (data.status) formData.append('status', data.status);
  if (data.logo) formData.append('logo', data.logo);


  return fetch(`${URL}/containers/${uuid}`, {
      method: 'PATCH',
      headers: headers,
      body: formData
  }).then(response => {
      return handleResponse(response);
  });
}

function initMassiveUpload(uuid, payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };

    return fetch(`${URL}/containers/${uuid}/documents/massive/init`, requestOptions)
        .then(handleResponse);
}

function completeMassiveUpload(uuid, objectName) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ objectName })
    };

    return fetch(`${URL}/containers/${uuid}/documents/massive/complete`, requestOptions)
        .then(handleResponse);
}

function getUploadProcesses(uuid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${URL}/containers/${uuid}/upload_process`, requestOptions)
        .then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors && data.errors.length > 0 && data.errors[0].detail) || (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
